module.exports = __webpack_public_path__ + "static/video_zh-cea2c89035f050e246900ad101025393.png";